import { render } from "./BaseDataTable.vue?vue&type=template&id=2ca762ba"
import script from "./BaseDataTable.vue?vue&type=script&lang=js"
export * from "./BaseDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__